import React from "react";
//import InfoBox from "../components/Infobox";
import MatchupList from "../components/Matchuplist";
import TeamList from "../components/TeamList";
import RegisterBox from "../components/RegisterBox";
import image from "../assets/football_pitch.jpg";
import ImageBox from "../components/ImageBox";
import { useContext } from "react";
import { PlatformContext } from "../components/Platform/PlatformContext";
import Button from "../components/Form/Button";

const Home: React.FC = () => {
  const platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;
  return (
    <div id="root" className="w-full flex">
      <div className="flex flex-col w-full max-w-screen-lg items-center justify-center mx-auto">
        {
          <div
            id="matchup"
            className="min-h-32 w-full flex items-center justify-center"
          >
            <MatchupList />
          </div>
        }
        <ImageBox
          headerText="What is the FFL"
          paragraphText="The Faculties Football League is a student football league in Munich, Germany. 
          The league is open to all students, regardless of their footballing ability, and is designed to be inclusive and fun. 
          Participating teams have a match every week, with the season running during the summer semester, with the top teams competing for the championship in the finals."
          isMobile={isMobile}
          imageSrc={image}
        />
        <TeamList />
        <RegisterBox
          headerText="How to register?"
          paragraphText="Registration is currently CLOSED and will reopen 15.04.2026!
          We will provide more information about the registration process and requirements for teams in the next few weeks, so stay tuned! "
          isMobile={isMobile}
          backgroundColor="#2d3748" // Custom background color (dark gray)
        ></RegisterBox>
        <RegisterBox
          headerText="Join the team"
          paragraphText={
            `Help us shape matchdays, plan events, manage teams, and grow the community that brings Munich’s student football scene to life! 🏆 ` +
            `Whether you're a football enthusiast, event planner, or just looking to contribute, there's a place for you in our league's journey. To apply, just full press the button below and fill out the form. `
          }
          isMobile={isMobile}
        >
          <Button
            type="button"
            text="Apply now!"
            className=" max-w-fit px-10 border-gray-50 border"
            bgColor="bg-inherit"
            onClick={() => window.open("https://tally.so/r/3jd97E")}
          />
        </RegisterBox>
      </div>
    </div>
  );
};

export default Home;
